import { Grid, Tooltip } from '@mui/material';
import React from 'react';

interface PieProgressProps {
  value: number; // 0 to 100
  size?: number; // size in pixels
  color?: string;
  overflowColor?: string; // color for the overflow part of the pie
  backgroundColor?: string;
  displayValue?: boolean; // whether to display the percentage value in the center
  title?: string; // optional title for the tooltip
}

const PieProgress: React.FC<PieProgressProps> = ({
  value,
  size = 100,
  color = '#4CAF50',
  overflowColor = '#f44336',
  backgroundColor = '#e0e0e0',
  displayValue,
  title,
}) => {
  const angle = Math.min((value / 100) * 360, 360);
  const radius = size / 2;
  const overflow = value > 100;

  // Convert angle to radians
  const radians = (angle - 90) * (Math.PI / 180) - 0.0000001;

  // Calculate end point of the arc
  const x = radius + radius * Math.cos(radians);
  const y = radius + radius * Math.sin(radians);

  const largeArc = value > 50 ? 1 : 0;

  const pathData = `
    M ${radius},${radius}
    L ${radius},0
    A ${radius},${radius} 0 ${largeArc} 1 ${x},${y}
    Z
  `;
  const fillcolor = overflow ? overflowColor : value == 100 ? color : backgroundColor;
  const valueString = value == 100 ? 'Full' : `${Math.round(value)}%`;
  return (
    <Tooltip
      title={
        <Grid container direction="column" alignItems="center" justifyContent="center">
          <Grid item xs={12}>
            <strong>{valueString}</strong>
          </Grid>
          {title && (
            <Grid item xs={12}>
              {title}
            </Grid>
          )}
        </Grid>
      }
      arrow
      placement="top"
    >
      <svg width={size} height={size}>
        {/* Full background circle */}
        <circle cx={radius} cy={radius} r={radius} fill={fillcolor} />

        {/* Filled arc */}
        <path d={pathData} fill={overflow ? overflowColor : color} />

        {/* Centered percentage text */}
        {displayValue && (
          <text
            x="50%"
            y="50%"
            dominantBaseline="middle"
            textAnchor="middle"
            fontSize={size * 0.2}
            fontWeight="bold"
            fill={overflow ? overflowColor : '#333'}
          >
            {Math.round(value)}%
          </text>
        )}
      </svg>
    </Tooltip>
  );
};

export default PieProgress;
